import { ReactElement } from 'react'
import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import classNames from 'classnames'
import { makeStyles } from 'beam'
import { useTranslation } from 'react-i18next'
import { dataTestIdPrefix } from './constants'
import HeaderActions from './HeaderActions'
import EvaluationSelector from './EvaluationSelector'
import { Container } from '@mui/material'

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    '@media print': {
      display: 'none',
    },
  },
  panelRoot: {
    maxWidth: '100%',
  },
  undockedPanel: {
    width: '100vw',
  },
  panelBody: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
  },
  panelHeaderActions: {
    alignItems: 'center',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1 1 auto',
  },
}))

function MultiEvaluation(): ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()
  const panelTitle = t('evaluation')
  return (
    <>
      {/* @ts-expect-error TODO: migrate to MUI v5 */}
      <Panel
        titleIcon={<BeamIcon>PlaylistCheck</BeamIcon>}
        title={panelTitle}
        dense
        variant="light"
        dataTestId={`${dataTestIdPrefix}panel`}
        headerActions={(<HeaderActions />)}
        headerTestId={`${dataTestIdPrefix}header`}
        classes={{
          root: classNames(classes.panelRoot),
          header: classes.header,
          body: classes.panelBody,
          actions: classNames(classes.panelHeaderActions),
        }}
      >
        {/* disabling gutter and width to use custom padding size*/}
        <Container disableGutters={true} maxWidth={false} sx={{ marginX: 0, paddingX: 2 }}>
          <EvaluationSelector />
        </Container>
      </Panel>
    </>
  )
}
export default MultiEvaluation
